<template>
  <div>
    <div class="flex p-3 justify-between items-center">
      <div :class="{ lock: data.lock }">
        <span
          class="flex items-center rounded-md bg-pink-600 text-white py-1 px-2 ml-2"
          v-show="data.new"
        >
          <p class="text-sm font-medium">New</p>
        </span>
      </div>

      <div
        :class="{ lock: data.lock }"
        class="flex gap-2 justify-end content-center items-center"
      >
        <a
          :href="data.tiktok_link"
          target="_blank"
          class="flex justify-center items-center content-center w-8 h-8 border border-indigo-600 p-1 rounded-lg font-semibold text-sm"
        >
          <Icon
            name="Tiktok"
            viewbox="0 0 32 32"
            fill="#667eea"
            stroke="#667eea"
            class="w-5"
          />
        </a>
        <div
          class="content justify-center items-center content-center mx-auto cursor-pointer w-8 h-8 rounded-lg border border-indigo-500 p-1 bg-white text-base leading-6 shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
          @click="toggleFavoriteState(data)"
          :class="{ 'bg-indigo-500 ': data.isFavorite }"
        >
          <div class="group w-full flex items-center justify-center">
            <div>
              <Icon name="Heart" fill="#fff" stroke="#667eea" class="w-6" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="relative">
      <div class="square" v-if="!data.lock && data.download_link">
        <video class="w-full" controls>
          <source :src="data.download_link" />
        </video>
      </div>
      <div class="square" v-if="data.lock">
        <div
          class="flex items-center justify-center pb-0 my-20 px-4 sm:px-6 lg:px-8"
        ></div>
      </div>
      <template v-if="data.lock">
        <UnlockTiktok class="relative top-0 unlock" />
      </template>
    </div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import Icon from "@/components/UI/Icon";
import UnlockTiktok from "@/components/UnlockTiktok";
export default {
  components: { Icon, UnlockTiktok },
  props: {
    data: Object,
    isCollection: Boolean,
  },
  setup() {
    const store = useStore();
    const primaryTextClamp = ref(true);
    const user = computed(() => store.state.user);
    const togglePrimaryTextClamp = () => {
      primaryTextClamp.value = !primaryTextClamp.value;
    };
    // const openOurPlansModal = () => {
    // store.commit("SET_OURPLANS_ACTIVE", true);
    // };
    const toggleFavoriteState = async (ad) => {
      if (ad.isFavorite) {
        await store.dispatch("REMOVE_FAVORITE_TIKTOK", {
          user_id: user.value.id,
          tiktok: ad,
        });
      } else {
        await store.dispatch("ADD_FAVORITE_TIKTOK", {
          user_id: user.value.id,
          tiktok: ad,
        });
      }
    };

    return { primaryTextClamp, togglePrimaryTextClamp, toggleFavoriteState };
  },
};
</script>

<style>
.lock {
  filter: blur(12px);
  pointer-events: none;
}
.text-606770 {
  color: #606770;
}
.square {
  width: 100%;
  background-color: black;
}
.clamp {
  max-height: calc(1rem * 7);
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.action {
  max-width: 100px;
  letter-spacing: normal;
  color: rgb(68, 73, 80);
  font-size: 12px;
  font-weight: bold;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, Arial, sans-serif;
  line-height: 26px;
  text-align: center;
  height: 30px;
  background-position: 0 0;
  border: 1px solid #667eea;
  border-radius: 10px;
  box-shadow: none;
  box-sizing: border-box;
  cursor: pointer;
  -webkit-font-smoothing: antialiased;
  font-weight: bold;
  padding: 0 11px;
  position: relative;
  text-shadow: none;
  transition: all 300ms cubic-bezier(0.1, 0.7, 0.1, 1), border-width 1ms;
  transition-property: background, border-color, border-width, color;
  vertical-align: middle;
}
</style>
